export function getErrorMessage(error, t) {
  const errorData = error?.data ?? error ?? {};
  const { key, message, context = {} } = errorData;
  if (!key) {
    return message ?? error?.error;
  }
  return t(key, context?.i18nOptions);
}
